import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { getEnglishCountryName } from "../common/options/flagOpt";
import { DataErasure, KoDataErasureReport, KoReportFormValues, KoUpReCycle, TotalCo2 } from "../models/dataErasure";
import { Kobehoved, KoForcastReceived } from "../models/forcastReceived";
import { collectionDate, country, customer, pickupNumber, receiveT1a, site } from "../common/options/koReportingOpt";

export default class ReportingStore {
  koForcastReceived: KoForcastReceived | null = null;
  koForcastReceivedLoading = false;

  kobhoveds: Kobehoved[] = [];
  kobhovedsLoading = false;

  koDataErasure: DataErasure | null = null;
  koDataErasureLoading = false;

  koDataErasureReports: KoDataErasureReport[] | [] = [];
  koDataErasureReportsLoading = false;

  koDataErasureReportsFiltered: KoDataErasureReport[] | [] = [];
  isSelectAll = false;

  koUpReCycle: KoUpReCycle | null = null;
  totalCo2: TotalCo2 | null = null;
  koUpReCycleLoading = false;

  sortOption = pickupNumber;
  sortValue = true;

  constructor() {
    makeAutoObservable(this);
  }

  resetStoreData = () => {
    this.koForcastReceived = null;
    this.kobhoveds = [];
    this.koDataErasure = null;
    this.koDataErasureReports = [];
    this.koDataErasureReportsFiltered = [];
    this.koUpReCycle = null;
    this.totalCo2 = null;

  }

  loadKoUpReCycle = async () => {
    this.koUpReCycleLoading = true;
    try {
      const response = await agent.KoOverview.getKoUpReCycle();
      runInAction(() => {
        this.koUpReCycle = response;
        this.calculateEquilentCo2(response);
        this.koUpReCycleLoading = false;
      });
    } catch (error) {
      runInAction(() => (this.koUpReCycleLoading = false));
    }
  };

  private calculateEquilentCo2 = (koUpReCycle: KoUpReCycle) => {
    if (koUpReCycle) {
      const desktop = koUpReCycle.defectiveDesktop + koUpReCycle.erasedDesktop;
      const laptop = koUpReCycle.defectiveLaptop + koUpReCycle.erasedLaptop;
      const mobile = koUpReCycle.defectiveMobileTlf + koUpReCycle.erasedMobileTlf;
      const tft = koUpReCycle.defectiveTft + koUpReCycle.erasedTft;

      if (desktop) {
        const desktopTreesCo2 = desktop * 7316;
        const laptopTreesCo2 = laptop * 9144;
        const tftCo2Trees = tft * 31.724;
        const mobileCo2Trees = mobile * 49;

        const totalTreesCo2 = desktopTreesCo2 + laptopTreesCo2 + tftCo2Trees + mobileCo2Trees;

        const desktopCarsCo2 = desktop * 26;
        const laptopCarsCo2 = laptop * 32;
        const tftCarsCo2 = tft * 109;
        const mobileCarsCo2 = mobile * 0.17;

        const totalCarsCo2 = desktopCarsCo2 + laptopCarsCo2 + tftCarsCo2 + mobileCarsCo2;

        const desktopLiterOfWaterCo2 = desktop * 1427;
        const laptopLiterOfWaterCo2 = laptop * 6247;
        const tftLiterOfWaterCo2 = tft * 2655;
        const mobileLiterOfWaterCo2 = mobile * 910;

        const totalLiterOfWaterCo2 = desktopLiterOfWaterCo2 + laptopLiterOfWaterCo2 + tftLiterOfWaterCo2 + mobileLiterOfWaterCo2;

        const desktopShowersCo2 = desktop * 7.14;
        const laptopShowersCo2 = laptop * 31.20;
        const tftShowersCo2 = tft * 13.30;
        const mobileShowersCo2 = mobile * 4.55;

        const totalShowersCo2 = desktopShowersCo2 + laptopShowersCo2 + tftShowersCo2 + mobileShowersCo2;

        const totalCo2: TotalCo2 = {
          treeCo2: Math.round(totalTreesCo2),
          carCo2: Math.round(totalCarsCo2),
          literOfWaterCo2:  Math.round(totalLiterOfWaterCo2),
          showerCo2:  Math.round(totalShowersCo2),
        }

        runInAction(() => this.totalCo2 = totalCo2)
      }
    }
  }

  loadKoForcastReceivedData = async (koNumber: string) => {
    this.koForcastReceivedLoading = true;
    try {

      const response = await agent.CustomerKoForcastReceived.getKoForcastReceived(koNumber);
      runInAction(() => {
        this.koForcastReceived = response;
        this.koForcastReceivedLoading = false;
      });
    } catch (error) {
      runInAction(() => (this.koForcastReceivedLoading = false));
    }
  };

  loadKobhedKoNos = async () => {
    this.kobhovedsLoading = true;
    try {
      const response = await agent.CustomerKoForcastReceived.getKobhovedKoNos();
      runInAction(() => {
        this.kobhoveds = response;
        this.kobhovedsLoading = false;
      })
    } catch (error) {
      runInAction(() => this.kobhovedsLoading = false)
    }
  }

  loadKoDataErasure = async (koNumber: string) => {
    this.koDataErasureLoading = true;
    try {

      const response = await agent.CustomerKoForcastReceived.getKoDataErasureReport(koNumber);
      runInAction(() => {
        this.koDataErasure = response;
        this.koDataErasureLoading = false;
      });
    } catch (error) {
      runInAction(() => (this.koDataErasureLoading = false));
    }
  };

  // totalPercentHandler = (element: KoDataErasureReport) => {
  //   const totalReceived = element.received.laptops + element.received.desktops + element.received.tft;
  //   const defectiveTotal = element.defective.laptops + element.defective.desktops + element.defective.tft;
  //   const erasedTotal = element.erased.laptops + element.erased.desktops + element.erased.tft;

  //   if(totalReceived>0) return element.progress = +((defectiveTotal / (totalReceived)) * 100) ;

  //   element.totalRecycle = +((defectiveTotal / (totalReceived)) * 100);
  //   element.totalUpcycle = +((erasedTotal / (totalReceived)) * 100);
  //   element.totalReceived= +totalReceived;

  //   if(totalReceived>0) return element.progress = ((defectiveTotal / (totalReceived)) * 100);
  //   if (defectiveTotal>0) return element.totalRecycle = +((defectiveTotal / (totalReceived)) * 100);
  //   if (erasedTotal>0) return element.totalUpcycle = +((erasedTotal / (totalReceived)) * 100);
  //   if(totalReceived>0) return element.totalReceived = +totalReceived;
  // }

  loadKoDataErasureReports = async () => {
    this.koDataErasureReportsLoading = true;
    try {

      const response = await agent.KoOverview.getKoDataErasureReports();
      runInAction(() => {
        response.forEach((element: KoDataErasureReport) => {
          element.isChecked = false;
          element.country = getEnglishCountryName(element.country);
          element.totalRecycle = 0;
          element.totalReceived = 0;
          element.totalUpcycle = 0;

          const totalReceived = element.received.laptops + element.received.desktops + element.received.tft;
          const defectiveTotal = element.defective.laptops + element.defective.desktops + element.defective.tft;
          const erasedTotal = element.erased.laptops + element.erased.desktops + element.erased.tft;

          // element.totalRecycle = +((defectiveTotal / (totalReceived)) * 100);
          // element.totalUpcycle = +((erasedTotal / (totalReceived)) * 100);
          // element.totalReceived= +totalReceived;


          // element.progress = ((defectiveTotal / (totalReceived)) * 100) ;
          // element.totalRecycle = +((defectiveTotal / (totalReceived)) * 100);
          // element.totalUpcycle = +((erasedTotal / (totalReceived)) * 100);
          // element.totalReceived= +totalReceived;

          if (defectiveTotal > 0)
            element.totalRecycle = + Math.round(((defectiveTotal / (totalReceived)) * 100));

          if (erasedTotal > 0)
            element.totalUpcycle = +Math.round(((erasedTotal / (totalReceived)) * 100));

          if (totalReceived > 0)
            element.totalReceived = +totalReceived;

          if (totalReceived > 0)
            element.progress = +(element.totalUpcycle + element.totalRecycle);

          // if (totalReceived > 0)
          // element.progress = +((defectiveTotal / (totalReceived)) * 100);

          // this.totalPercentHandler(element)
        });
        this.koDataErasureReports = response;
        this.koDataErasureReportsFiltered = response;

        this.koDataErasureReportsLoading = false;
      });
    } catch (error) {
      runInAction(() => (this.koDataErasureReportsLoading = false));
    }
  };



  koDataErasureFilter = (formValues: KoReportFormValues) => {
    if (formValues.searchBy) {
      let searchText = formValues.searchText?.toUpperCase();

      //Include search
      if (searchText) {
        if (formValues.searchBy === 'PickupNo') {
          const koDataErasureReportsFiltered = this.koDataErasureReports.filter(x => x.pickupNumber.toUpperCase().includes(searchText));
          runInAction(() => (this.koDataErasureReportsFiltered = koDataErasureReportsFiltered));
        }
        if (formValues.searchBy === 'Reference') {
          const koDataErasureReportsFiltered = this.koDataErasureReports.filter(x => x.reference.toUpperCase().includes(searchText));
          runInAction(() => (this.koDataErasureReportsFiltered = koDataErasureReportsFiltered));
        }
        if (formValues.searchBy === 'City') {
          const koDataErasureReportsFiltered = this.koDataErasureReports.filter(x => x.customerCity.toUpperCase().includes(searchText));
          runInAction(() => (this.koDataErasureReportsFiltered = koDataErasureReportsFiltered));
        }
        if (formValues.searchBy === 'Country') {
          const koDataErasureReportsFiltered = this.koDataErasureReports.filter
            (x => (x.country.toUpperCase().includes(searchText)))
          runInAction(() => (this.koDataErasureReportsFiltered = koDataErasureReportsFiltered));
        }
      }

      //Date Search
      if (formValues.searchBy === 'CollectionDate') {
        if (formValues.startDate && formValues.endDate) {
          const koDataErasureReportsFiltered = this.koDataErasureReports.filter(x => new Date(x.collectionDate) >= new Date(formValues.startDate)
            && new Date(x.collectionDate) <= new Date(formValues.endDate));
          runInAction(() => (this.koDataErasureReportsFiltered = koDataErasureReportsFiltered));
        }
      }
      if (formValues.searchBy === 'ReportDate') {
        if (formValues.startDate && formValues.endDate) {
          const koDataErasureReportsFiltered = this.koDataErasureReports.filter(x => new Date(x.receivedT1A) >= new Date(formValues.startDate)
            && new Date(x.receivedT1A) <= new Date(formValues.endDate));
          runInAction(() => (this.koDataErasureReportsFiltered = koDataErasureReportsFiltered));
        }
      }
    }
  }
  koDataErasureFilterReset = () => {
    runInAction(() => {
      this.koDataErasureReportsFiltered = this.koDataErasureReports;
      this.sortOption = pickupNumber;
      this.sortValue = true;
    });
  }

  koDataErasureCheckHandler = (pickupNumber: string) => {
    if (pickupNumber && this.koDataErasureReportsFiltered.length > 0) {
      const filteredData = [...this.koDataErasureReportsFiltered];
      let index = filteredData.findIndex(x => x.pickupNumber === pickupNumber);
      if (index >= 0) {
        let item = filteredData[index];
        item = {
          ...item,
          isChecked: !item.isChecked
        };
        filteredData[index] = item;
        const isSelectAll = filteredData.every(x => x.isChecked);
        runInAction(() => {
          this.koDataErasureReportsFiltered = filteredData;
          this.isSelectAll = isSelectAll;
        })
      }
    }
  }

  selectAllHandler = () => {
    if (this.koDataErasureReportsFiltered.length > 0) {
      const filteredData = [...this.koDataErasureReportsFiltered];

      filteredData.forEach((data) => {
        data.isChecked = !this.isSelectAll;
      })

      runInAction(() => {
        this.koDataErasureReportsFiltered = filteredData;
        this.isSelectAll = !this.isSelectAll;
      })
    }

  }
  sortKoReportingTable = (type: string) => {
    if (this.sortOption !== type) {
      this.sortValue = true;
    }
    else {
      this.sortValue = !this.sortValue;
    }
    runInAction(() => {
      this.sortOption = type;
      if (type === pickupNumber) {
        this.koDataErasureReportsFiltered = this.koDataErasureReportsFiltered.sort((a, b) => {
          if (this.sortValue) {
            if (a.pickupNumber < b.pickupNumber)
              return -1;
            if (a.pickupNumber > b.pickupNumber)
              return 1;
            return 0;
          }
          else {

            if (a.pickupNumber > b.pickupNumber)
              return -1;
            if (a.pickupNumber < b.pickupNumber)
              return 1;
            return 0;
          }
        });

      }
      if (type === customer) {
        this.koDataErasureReportsFiltered = this.koDataErasureReportsFiltered.sort((a, b) => {
          if (this.sortValue) {
            if (a.customer < b.customer)
              return -1;
            if (a.customer > b.customer)
              return 1;
            return 0;
          }
          else {
            if (a.customer > b.customer)
              return -1;
            if (a.customer < b.customer)
              return 1;
            return 0;
          }
        });
      }
      if (type === site) {
        this.koDataErasureReportsFiltered = this.koDataErasureReportsFiltered.sort((a, b) => {
          if (this.sortValue) {
            if (a.customerCity < b.customerCity)
              return -1;
            if (a.customerCity > b.customerCity)
              return 1;
            return 0;
          }
          else {
            if (a.customerCity > b.customerCity)
              return -1;
            if (a.customerCity < b.customerCity)
              return 1;
            return 0;
          }
        });
      }
      if (type === country) {
        this.koDataErasureReportsFiltered = this.koDataErasureReportsFiltered.sort((a, b) => {
          if (this.sortValue) {
            if (a.country < b.country)
              return -1;
            if (a.country > b.country)
              return 1;
            return 0;
          }
          else {
            if (a.country > b.country)
              return -1;
            if (a.country < b.country)
              return 1;
            return 0;
          }
        });
      }
      if (type === collectionDate) {
        this.koDataErasureReportsFiltered = this.koDataErasureReportsFiltered.sort((a, b) => {

          const dateA = new Date(a.collectionDate || new Date());
          const dateB = new Date(b.collectionDate || new Date());

          if (this.sortValue) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }
      if (type === receiveT1a) {
        this.koDataErasureReportsFiltered = this.koDataErasureReportsFiltered.sort((a, b) => {

          const dateA = new Date(a.receivedT1A || new Date());
          const dateB = new Date(b.receivedT1A || new Date());

          if (this.sortValue) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }

    })
  }
}